import { isAuthenticated } from '@/service/axios';
import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTheme } from './ThemeProvider';

export function ProtectedRoute({
  children,
  loginPage = '/',
}: { loginPage?: string; showToast?: boolean } & PropsWithChildren) {
  const theme = useTheme();
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to={loginPage} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
